var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"appCard"},[_c('header',{staticClass:"appCard-header"},[_c('h4',{staticClass:"title"},[_vm._t("header")],2)]),_c('section',{staticClass:"appCard-content"},[_vm._t("content")],2),_c('footer',{staticClass:"appCard-footers"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }